import React from 'react';
import './ErrorPage.css';

const Error = () => {
  return (
    <div className="error-page">
      <div className="error-container">
        <h1>Oops! Something went wrong.</h1>
        <p>We're working to fix it.</p>

        <div className="visual-container">
          <img
            src="https://www.impactbnd.com/hubfs/404-error-page-examples-best.jpg"
            alt="img"
            className="error-image"
          />
        </div>

        <div className="message-box">
          <p>
            It seems we've encountered an issue, but don't worry. We're already on it. 
            Please use the options below to navigate further.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Error;
